import React from 'react';
import {
  Headline,
  Body,
  designSystemToken,
} from '@lightricks/react-design-system';
import {styled} from '@mui/material';

interface EmptyStateProps {
  title?: string;
  message?: string;
}

const StyledEmptyState = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '40px 20px',
  backgroundColor: designSystemToken('semantic.bg.transparent'),
  margin: '20px 0',
}));

const StyledTitle = styled(Headline)(() => ({
  marginBottom: '8px',
}));

const StyledMessage = styled(Body)(() => ({
  maxWidth: '400px',
}));

function EmptyState({title, message}: EmptyStateProps) {
  return (
    <StyledEmptyState>
      <StyledTitle size="md">{title}</StyledTitle>
      <StyledMessage size="md">{message}</StyledMessage>
    </StyledEmptyState>
  );
}

export default EmptyState;
